import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCoCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.500031H10V4.50003H4V10.5H0V0.500031Z" fill="currentColor" />
    <path d="M16 6.50003H6V16.5H16V6.50003Z" fill="currentColor" />
  </svg>
);
export default SvgCoCopy;
